import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {userAccountsDomainsService} from '../apiclient/userAccountsDomains/userAccountsDomains.service';
import {ToolsService} from '../tools/tools.service';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardMainService implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private userAccountsDomainsService: userAccountsDomainsService,
    private tools: ToolsService
  ) {
  }

  determineUrl(): boolean {
    const origin = window.location.origin;

    // Mode test
    if (!environment.production) {
      return true;
    }

    // Mode production
    else if (origin.includes('projetclient-209012.ew.r.appspot.com')) {
      return true;
    }

    return origin == 'https://webshop.fulleapps.io';
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    const that = this;

    let determineUrl = this.determineUrl();

    return new Promise(function (resolve) {

      that.authService.checkIfAuth().then(function (data) {

        that.tools.removeStor("domainUser");
        that.tools.setFavicone(false);

        if (!determineUrl) {

          that.userAccountsDomainsService.getUserAccountDomain(window.location.host).subscribe((domain: any) => {
            if (domain) {
              that.tools.setStor("domainUser", true);
              that.tools.setFavicone(true);
              resolve(true);
            } else {
              //test
              that.tools.removeStor("domainUser");
              that.tools.setFavicone(false);
              resolve(true);
            }
          })

        } else {
          that.tools.removeStor("domainUser");
          that.tools.setFavicone(false);
          resolve(true);

        }

      }).catch(function (err) {
        console.error('err', err)
        that.tools.setFavicone(false);
        that.tools.removeStor("domainUser");
        resolve(false);
        that.router.navigate(["/auth/home"]);
      })
    })
  }
}
